/**
 * Add source code to any inputs named pc
 *
 * @param {string} sourcecode
 *   The sourcecode
 */
const addSourceCodeToInputs = (sourcecode) => {
  const sourcecodeInputs = document.getElementsByName("pc");

  for (let i = sourcecodeInputs.length - 1; i >= 0; i -= 1) {
    sourcecodeInputs[i].value = sourcecode;
  }
};

export default addSourceCodeToInputs;
